import React from 'react';
import '../template-file-css/document-file-template.css';



export const HFI_InformedConsent = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='HFI_InformedConsent' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><center><h3>Informed Consent For Telehealth Services</h3></center></p>

                <p className='w-750'><b>Introduction</b>
                    <br />
                    You are going to have a clinical visit using videoconferencing technology.
                    You will be able to see and hear the provider and they will be able to see and hear you, just as if you were in the same room.
                    <br /><br />

                    Telehealth is the delivery of healthcare services when the healthcare provider and person served are not in the same physical location through the use of technology. Providers may include primary care practitioners, specialists, licensed individuals etc.
                    Electronically-transmitted information may be used for diagnosis, therapy; follow-up and/or person served education.
                    <br /><br />

                    The interactive electronic systems used will incorporate network and software security protocol to protect the confidentiality of persons served identification will include measures to safeguard the data and to ensure its integrity against intentional or unintentional corruption. </p>

                <p className='w-750'><b>Purpose</b><br />
                    The purpose of this form is to obtain your consent to participate in a telehealth consultation during your services with the Heritage Foundation, Inc.
                </p>

                <p className='w-750'><b>Potential Benefits</b></p>

                <ol>
                    <li>Improved access to services by enabling person served to remain in his/her physical space (or at a remote site).</li>
                    <li>Person served remains close to home where local healthcare providers can maintain continuity of care.</li>
                    <li>Reduced need to travel for the person served.</li></ol>

                <p className='w-750'><b>Potential Risks</b><br />
                    As with any services, there are potential risks associated with the use of telehealth. These risks include, but are not limited to:</p>

                <ol>
                    <li>Information transmitted may not be sufficient (e.g., poor resolution of images).</li>
                    <li>Technology problems may delay evaluation and treatment for session.</li>
                    <li>A provider may determine that the telehealth service is not yielding sufficient information to make an appropriate clinical decision. </li>
                    <li>The provider(s) are not able to provide emergency medical services to the person served through the use of telehealth equipment nor provide immediate response for emergencies therefore acknowledgment of local hospital(s) and emergency contact numbers are required. </li>
                    <li>In very rare instances, security protocols could fail, causing breach of privacy of personal information. </li>
                    <li>A lack of access to complete record may result in limited historical information.</li>
                </ol>

                <p className='w-750'><b>Records </b><br />
                    All existing laws regarding your access to record information apply to telehealth services. Please note not all telehealth communications are recorded and stored. </p>

                <p className='w-750'><b>Confidentiality</b><br />
                    Reasonable and appropriate efforts have been made to eliminate any confidentiality risks associated with the telehealth consultation, and all existing confidentiality protections under federal and Georgia state laws apply to information disclosed while receiving services.</p>

                <p className='w-750'><b>Rights</b><br />
                    You may withhold or withdraw consistent to the telehealth services at any time without affecting your right to future services, or risking the loss or withdrawal of any program benefits to which you would otherwise be entitled. </p>

                <p className='w-750'><b>Disputes</b><br />
                    You agree that any dispute related to telehealth services will be resolved in Georgia and that Georgia law shall apply to all disputes.  </p>

                <p className='w-750'><b>Risks, Consequences  & Benefits</b><br />
                    You have been advised of all the potential risks, consequences and benefits of telehealth services. Your provider has discussed with you the information proved above. You have had the opportunity to ask questions about the information presented on this form and the telehealth services. All your questions have been answered, and you understand the written information provided above. </p>

                <p className='w-750'><b>By signing this form, I understand and agree to the following</b>
                </p>

                <ol>
                    <li>I understand that the laws that protect the privacy and confidentiality of information also apply to telehealth. No information obtained during telehealth services which identifies me will be disclosed to researchers or other entitled without my consent. </li>
                    <li>I understand that I have the right to withhold or withdraw my consent to the use of telehealth during the course of my care at any time. I understand that my withdrawal of consent will not affect any future services, nor will it subject me to the risk of loss or withdrawal of any services to which I am otherwise entitled. </li>
                    <li>I also understand that if the provider believes I would be better served by a traditional face-to-face encounter, they may, at any time stop the telehealth visit and schedule a face-to-face visit. </li>
                    <li>I understand telehealth services may involve electronic communication of my personal information to other providers who may be located in other areas. </li>
                    <li>I understand that I may expect the anticipated benefits from the use of telehealth in my services, but that no results can be guaranteed or assured</li>
                </ol>

                <p className='w-750'><b>Person Service Consent To The Use of Telehealth</b><br /><br />
                    I have read and understand the information provided above regarding telehealth, have discussed it with my provider and or staff as may be designated, and all of my questions have been answered to my satisfaction.
                    I hereby give my informed consent for the use of telehealth for my services. <br /><br />
                    I hereby consent to and authorize<b>The Heritage Foundation, Inc.</b> to use telehealth in the course of my services. </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature of Person Served (or person authorized to sign) : </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>If authorized signer relationship to Person Served:</td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Witness:</td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>

               <table>
                <tr>
                    <td className='w-750'>
                    <span className='eleHeader'>I have been offered a copy of this consent form (patient's) </span>
                    </td>
                </tr>
                <tr>
                    <td className='w-750'>
                    <input type='radio' id='rbIHaveOfferedConsent_Yes' name='rbIHaveOfferedConsent' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbIHaveOfferedConsent_No' name='rbIHaveOfferedConsent' className='add-only' value='No' /> No
                    </td>
                </tr>
               </table>
              


            </div>
        </form>

    )
}  
